import { useForm } from 'react-hook-form'
import { Alert, Box, Button, TextField, Typography } from '@mui/material'

const PasswordResetForm = (props) => {
  const { register, handleSubmit, control, formState: { errors } } = useForm()

  const submit = (data) => {
    props.process(data);
  };

  return (
    <>
      <Box sx={{ width: '100%', alignItems: 'center'}}>
        <form>
          <Box sx={{ ml: 1 }}>
            <Typography variant={'body2'}>パスワードリセットするユーザのメールアドレスを入力してください</Typography>
            <Typography variant={'body2'}>登録済みである場合パスワードリセットのメールが送信されます</Typography>
            <TextField
              label='メールアドレス'
              sx={{ mt:3,mb: 1, ml: 8, mr: 1 }}
              {...register('email', {
                required: true,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                },
              })}
              size='small'
            />
            {errors.email?.type === 'required' && <Alert sx={{ml:3,width:'80%'}} severity="warning">
              メールアドレスは必須です！
            </Alert>}
            {errors.email?.type === 'pattern' && <Alert sx={{ml:3,width:'80%'}} severity="warning">
              メールアドレスの形式が不正です
            </Alert>}
          </Box>
          <Button sx={{mt:1,ml:10}} variant='contained' onClick={handleSubmit(submit)} ><Typography>パスワードリセット</Typography></Button>
        </form>
      </Box>
    </>
  );

}

export default PasswordResetForm;